import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';


export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const image004 = useDocImage('webhooks-img', 'image-004.png');
  const image005 = useDocImage('webhooks-img', 'image-005.png');

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper">
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className="dashboard-page-wrap document-page-wrap">
              <h1 className="mt-0 text-primary">{t('documentation.privacyPolicy.title')}</h1>
              <p className="header-para">{t('documentation.privacyPolicy.intro')}</p>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.privacyPolicy.accessing.title')}
                </div>
                <div className="card-body">
                  <ul>
                    <li>{t('documentation.privacyPolicy.accessing.steps.step1')}</li>
                    <li>{t('documentation.privacyPolicy.accessing.steps.step2')}</li>
                    <img
                      src={image004}
                      alt={t('documentation.privacyPolicy.accessing.imageAlt')}
                      className="img-fluid pt-20 pb-20"
                    />
                  </ul>
                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.privacyPolicy.editorBasics.title')}
                </div>
                <div className="card-body">
                  <p><b>{t('documentation.privacyPolicy.editorBasics.formattingTitle')}</b></p>
                  <ul>
                    <li>{t('documentation.privacyPolicy.editorBasics.formattingItems.item1')}</li>
                    <li>{t('documentation.privacyPolicy.editorBasics.formattingItems.item2')}</li>
                    <li>{t('documentation.privacyPolicy.editorBasics.formattingItems.item3')}</li>
                  </ul>

                  <p className="mt-3"><b>{t('documentation.privacyPolicy.editorBasics.tablesTitle')}</b></p>
                  <ul>
                    <li>{t('documentation.privacyPolicy.editorBasics.tableItems.item1')}</li>
                    <li>{t('documentation.privacyPolicy.editorBasics.tableItems.item2')}</li>
                     <img
                      src={image005}
                      alt={t('documentation.privacyPolicy.editorBasics.imageAlt')}
                      className="img-fluid pt-20 pb-20"
                    />
                  </ul>
                </div>
              </div>

            

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.privacyPolicy.saving.title')}
                </div>
                <div className="card-body">
                  <ul>
                    <li>{t('documentation.privacyPolicy.saving.items.item1')}</li>
                    <li>{t('documentation.privacyPolicy.saving.items.item2')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
